var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"copy":function($event){return _vm.copyText($event)}}},[_vm._v(" "+_vm._s(_vm.data.question)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }